var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15114 7.18734C11.0894 3.22565 16.4307 1 22.0002 1C27.5697 1 32.9111 3.22565 36.8493 7.18734C40.7875 11.149 43 16.5222 43 22.1249C43 27.7276 40.7875 33.1008 36.8493 37.0624L22.0002 52L7.15114 37.0624C5.201 35.1009 3.65405 32.7721 2.59864 30.2091C1.54322 27.6461 1 24.8991 1 22.1249C1 19.3507 1.54322 16.6037 2.59864 14.0407C3.65405 11.4777 5.201 9.14889 7.15114 7.18734ZM22.0002 28.1603C23.5914 28.1603 25.1175 27.5244 26.2426 26.3925C27.3678 25.2607 27.9999 23.7256 27.9999 22.1249C27.9999 20.5242 27.3678 18.9891 26.2426 17.8572C25.1175 16.7254 23.5914 16.0895 22.0002 16.0895C20.409 16.0895 18.883 16.7254 17.7578 17.8572C16.6327 18.9891 16.0006 20.5242 16.0006 22.1249C16.0006 23.7256 16.6327 25.2607 17.7578 26.3925C18.883 27.5244 20.409 28.1603 22.0002 28.1603Z",
    fill: "#B2F5EA",
    stroke: "#2C7A7B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.7ec58c102c65d9f555cda110212ec825.svg";
export { ForwardRef as ReactComponent };